import * as R from 'ramda'

import { SET_ENTITIES } from 'actions'

const initialState = {
  allIds: [],
  entities: {},
}

const userReducer = (state = initialState, action) => {
  const { allIds, entities } = state
  switch (action.type) {
    case SET_ENTITIES: {
      return {
        allIds: R.union(allIds, action.allIds.user),
        entities: R.merge(entities, action.entities.user),
      }
    }
    default:
      return state
  }
}

export default userReducer

export const getUsers = (state) => state.allIds.map((id) => state.entities[id])



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/reducers/data/user.js